export default __webpack_public_path__ + "static/media/mon-blue.ceb05ac3.png";